import React from 'react';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

const Button = ({ children, onClick, className, variant = 'primary', size = 'md', ...props }) => {
  const baseStyles = "relative overflow-hidden rounded-full font-bold transition-transform active:scale-95 shadow-md hover:shadow-lg hover:-translate-y-1";
  
  const variants = {
    primary: "bg-gradient-to-br from-primary to-accent1 text-white border-none",
    secondary: "bg-white text-primary border-2 border-primary",
    accent: "bg-accent2 text-white",
  };

  const sizes = {
    sm: "px-3 py-1.5 text-sm",
    md: "px-6 py-3 text-lg",
    lg: "px-8 py-4 text-xl",
  };

  return (
    <button 
      onClick={onClick}
      className={twMerge(clsx(baseStyles, variants[variant], sizes[size]), className)}
      {...props}
    >
      <span className="relative z-10 flex items-center justify-center gap-2">
        {children}
      </span>
      {/* Shine effect */}
      <div className="absolute inset-0 bg-gradient-to-b from-white/20 to-transparent pointer-events-none" />
    </button>
  );
};

export default Button;